import reloadReadingPane from '../actions/reloadReadingPane';
import { reloadReadingPaneAfterClosingSxS } from 'owa-sxs-store';
import { getActiveContentTab, TabType } from 'owa-tab-store';
import { orchestrator } from 'satcheljs';

orchestrator(reloadReadingPaneAfterClosingSxS, () => {
    const activeTab = getActiveContentTab();
    if (activeTab && activeTab.type === TabType.Primary) {
        reloadReadingPane();
    }
});
